import { IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import { HorizontalDivider } from 'src/components/atoms/Divider/Divider.styles';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const NotificationContainer = styled.div<{
  notificationsOpen?: boolean;
  newNavEnabled?: boolean;
}>`
  display: flex;
  width: ${(props) => (props.newNavEnabled ? '370px' : '350px')};
  ${(props) =>
    props.newNavEnabled &&
    `
    transition: opacity ${props.notificationsOpen ? '0.4s' : '0.3s'};
    transition-delay: ${props.notificationsOpen ? '0.2s' : '0s'};
    overflow: hidden;
    white-space: nowrap;
    opacity:${props.notificationsOpen ? '1' : '0'};
    `}
  height: 100%;
  padding: 20px;
  align-items: start;
  padding: 10px;
  background-color: ${({ theme }) =>
    theme.atlas.semantic.color.surface.default};
  &:hover {
    background-color: ${({ theme }) =>
      theme.atlas.semantic.color.surface.variant};
  }
`;

export const NotificationContainerRight = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
`;
export const StyledIconButton = styled(IconButton)`
  padding: 0;
  height: 24px;
  color: ${({ theme }) => theme.atlas.semantic.color.type.default};
  background-color: none;
  border-radius: 100%;
  width: 24px;
`;
export const NotificationItemContainer = styled.div`
  background-color: ${({ theme }) =>
    theme.atlas.semantic.color.surface.default};
`;

export const NotificationContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: 0;
`;

export const NotificationHeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 5px;
`;

export const NotificationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
`;

export const NotificationActions = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const StyledLink = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: start;
  text-decoration: none;
  padding: 0;
  color: ${({ theme }) => theme.atlas.semantic.color.type.default};
  width: 100%;
`;

export const StyledListItemText = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  text-wrap: auto;
`;

export const StyledListItemHeader = styled.div<{ hasButton: boolean }>`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  color: ${({ theme }) => theme.atlas.semantic.color.type.default};
  font-size: 14px;
  font-weight: 600;
  ${(props) => !props.hasButton && 'padding-bottom: 5px;'}
  text-wrap: auto;
`;

export const StyledDivider = styled(HorizontalDivider)`
  margin-left: 10px;
`;

export const CreatedAtContainer = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)};
  color: ${({ theme }) => theme.atlas.semantic.color.type.muted};
`;
